module.exports = __webpack_public_path__ + "300_Ashland_Brochure_WEB.114c99b4.pdf";


//////////////////
// WEBPACK FOOTER
// ./client/download/300_Ashland_Brochure_WEB.pdf
// module id = 470
// module chunks = 0